import eyercloud from '@/config/eyercloud'

class ExamDataService {

  async get(examDataID) {
    let response = await eyercloud.get(`/api/v2/eyercloud/examData/get`, {
      params: {
        id: examDataID
      }
    })
    return response.data
  }

  async list(params) {
    let response = await eyercloud.get(`/api/v2/eyercloud/examData/list`, { params })
    return response.data
  }

  async remove(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/examData/remove`, params)
    return response.data
  }

  async download(params) {

    let response = await eyercloud.post(`/api/v2/eyercloud/examData/download-link`, params)
    return response.data
  }

  // HEAD asks the same permission checks as the download without receiving the file.
  // Resolves false when the axios interceptor already redirected the user (403, 402, 503).
  async canDownloadFile(params) {
    const response = await eyercloud.head(`/api/v2/eyercloud/examData/download-file`, { params })
    return !!response
  }

  getDownloadFileUrl(params) {
    const BASE_URL = process.env.VUE_APP_API_URL
    const query = new URLSearchParams(params).toString()
    return `${BASE_URL}/api/v2/eyercloud/examData/download-file?${query}`
  }

  async save(examData, blob) {
    let formData = new FormData()
    formData.append('examData', JSON.stringify(examData))
    formData.append('data', blob) // binary data ALWAYS at the end

    let response = await eyercloud.post(`/api/v2/eyercloud/examData/save`, formData)
    return response.data
  }

  async getUploadUrlOthers(params) {
    let response = await eyercloud.get(`/api/v2/eyercloud/examData/get-upload-url-others`, {
      params
    });
    return response.data;
  }

  async saveOthers(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/examData/save-others`, params);
    return response.data;
  }

  async uploadFileUrl(params) {
    const formData = new FormData();

    // Injects all tokens generated by AWS into the backend (Policy, Signature, etc.)
    if (params.uploadFields) {
      Object.keys(params.uploadFields).forEach(key => {
        formData.append(key, params.uploadFields[key]);
      });
    }

    // The file MUST be the last item in the FormData.
    formData.append('file', params.file);

    let response = await eyercloud.external.post(params.uploadUrl, formData);
    return response;
  }

  async createPanoramic(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/examData/create-panoramic`, params)
    //let response = {data: '807313f6-f8db-4586-90e8-9705d15ed167'}
    return response.data
  }

  async createPatientProgression(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/examData/create-patient-progression`, params)
    //let response = {data: '807313f6-f8db-4586-90e8-9705d15ed167'}
    return response.data
  }

  async createStereo(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/examData/create-stereo`, params)
    return response.data
  }

  async createPreview(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/examData/create-preview`, params)
    return response.data
  }

  async saveCroppedImage(params) {
    let formData = new FormData()
    formData.append('id', params.id)
    formData.append('data', params.image) // binary data ALWAYS at the end

    let response = await eyercloud.post(`/api/v2/eyercloud/examData/save-cropped-image`, formData)
    return response.data
  }

  async createHeatmap(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/examData/create-ras`, params)
    return response.data
  }

  async generateConsentPdf(params) {
    const response = await eyercloud.post(`/api/v2/eyercloud/patient/consent/generate`, params)
    return response.data
  }

  async updateLaterality(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/examData/swap-laterality`, params)
    return response.data
  }
}
const examDataService = new ExamDataService();
export default examDataService;
